var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagAuDe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag_of_Germany_and_Austria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.4,
    height: 30,
    viewBox: "0 0 45.4 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_121",
    width: 45.373,
    height: 29.741,
    transform: "translate(0.027)",
    fill: "#d81e05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    d: "M0,0H45.4V9.471H15.133Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    d: "M914.207,600H900v9.472h28.414Z",
    transform: "translate(-900 -589.736)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_129",
    d: "M0,1200H14.586v9.471Z",
    transform: "translate(30.814 -1179.471)",
    fill: "#ffce00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAuDe);
export default __webpack_public_path__ + "static/media/flag_au_de.42ee35fc2ef519be6075bd83dd83b094.svg";
export { ForwardRef as ReactComponent };